export const TASK_COCKPIT = 'TASK_COCKPIT';

export const canAccessTaskCockpit = (user = {}) =>
  Object.entries(user.areas || {}).some(([key, allowed]) => allowed && ['user', 'all'].includes(key.toLowerCase()));

export const landingPageOptions = (apps, allowTasks, translate) => [
  ...apps,
  ...(allowTasks ? [{ Title: translate('admin.access.users.task_cockpit'), UUID: TASK_COCKPIT }] : []),
  { Title: 'Launchpad', UUID: null }
];
